// extracted by mini-css-extract-plugin
module.exports = {"checkout-list":"CheckoutList_checkout-list__36PhA","row":"CheckoutList_row__2RgDM","subtotal":"CheckoutList_subtotal__lJKqE","total":"CheckoutList_total__2JS1h"};